import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';
import { memo } from 'react';
import { NumericFormat } from 'react-number-format';

interface Props {
	value?: number;
	showZero?: boolean;
}

const NumberFormatted = ({ showZero, value }: Props) => {
	if (!showZero && !value) {
		return <div>{LONG_DASH}</div>;
	}

	return (
		<div>
			{(showZero && value === 0) || value ? (
				<NumericFormat displayType="text" thousandSeparator="," value={value} />
			) : (
				LONG_DASH
			)}
		</div>
	);
};
const _NumberFormattedExport = memo(NumberFormatted);

export { _NumberFormattedExport as NumberFormatted };
